import { PreloadedQuery } from 'react-relay';

import { orgIdToAri } from '@townsquare/ari-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';

import TeamsAppForYouAGGQuery, {
	TeamsAppForYouAGGQuery as TeamsAppForYouAGGQueryType,
} from '../agg/__generated__/TeamsAppForYouAGGQuery.graphql';

export const teamsAppForYouAGGResource: RouteResource<
	PreloadedQuery<TeamsAppForYouAGGQueryType, Record<string, unknown>>
> = createRelayResource<TeamsAppForYouAGGQueryType>({
	getQuery: (_routerContext, resourceStoreContext) => {
		const context = resourceStoreContext as unknown as HomeResourceContext;

		const organizationId = context.workspace?.organisationId ?? context.orgId ?? '';
		const siteId = (context.collabContext?.rovoWorkspace || context.workspace?.cloudId) ?? '';

		return {
			query: TeamsAppForYouAGGQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				organizationId: orgIdToAri(organizationId),
				siteId,
				teamFilter: {
					membership: {
						memberIds: [context.user?.accountId],
					},
				},
				teamSortBy: [
					{
						field: 'DISPLAY_NAME',
						order: 'ASC',
					},
				],
			},
			cacheKey: 'relay-teams-app-for-you-agg',
			options: { fetchPolicy: 'store-and-network' },
		};
	},
});
